<template>
  <div class="table-stips">
    <BTable
      :responsive="true"
      :bordered="true"
      :label-stacked="true"
      :stacked="'xl'"
      :fields="table_fields"
      :items="items_table"
      table-class="table-centered datatable table-card-list text-center"
      thead-tr-class="green-color p-0 shadow text-uppercase"
      field-column-class="green-color"
    >
      <template
        v-for="field in table_fields"
        v-slot:[`cell(${field})`]="{ item }"
        :key="field"
      >
        <div >
          <!-- Specijalan prikaz za Proizvod -->
          <div
            v-if="field  === 'Proizvod'"
            class="align-items-center d-flex"
          >
            <i
              :class="`esei icon-${findIcon(item[field]).img2} esei-default avatar-block text-white bg-${findIcon(item[field]).color} p-1`"
            ></i>

            <p class="d-flex ms-2 pt-table-text">
              {{ formatFieldsTabel(field, item[field]) }} 
            </p>
          </div>

          <!-- Ostale kolone -->
          <div v-else>
            {{ formatFieldsTabel(field, item[field]) }} 
          </div>
        </div>
      </template>
      <template
        v-for="field in table_fields"
        v-slot:[`cell(${field.key})`]="{ item }"
        :key="field.key"
      >
        <div >
          <!-- Specijalan prikaz za Proizvod -->
          <div
            v-if="field.key  === 'cene' || field.key  === 'jm'"
            class="align-items-center d-flex"
          >
              {{ formatFieldsTabel(field, item[field.key]) }}   
          </div>

          <!-- Ostale kolone -->
          <div v-else>
            {{ formatFieldsTabel(field, item[field.key]) }} din
          </div>
        </div>
      </template>
    </BTable>
    </div>
  
</template>

<script setup>
import { BTable } from 'bootstrap-vue-next'
import FindIcon from '~/util/findProductsIcon'
import findTitle from '~/util/ProductTableLoacalization/find-product'
import listOfMonths from '~/util/listOfMonth/months'

const props = defineProps({
  table_fields: {
    type: Array,
    required: true
  },
  items_table: {
    type: Array,
    required: true
  },
  height: {
    type: Number,
    required: false
  },
  stacked: {
    type: String,
    default: 'xl'
  },
  lang: {
    type: String,
    default: 'sr'
  },
  rate: {
    type: Object,
    default: {
      rate: 117.2
    }
  },
  display_avatar: {
    type: Boolean,
    default: true
  },
  display_locale: {
    type: Boolean,
    default: true
  },
  display_month: {
    type: Boolean,
    default: false
  }
})

const findIcon = (data) => {
  const name = String(data ?? '').split(' ')[0]
  
  
  return FindIcon.find(name)
}

const formatFieldsTabel = (title, val) => {
  try {
    if (title.toLowerCase() === 'proizvod' && props.display_locale) {
   
      
      return findTitle.find(props.lang, val)
    }
    if (title.toLowerCase() === 'pakovanje' && props.display_locale) {
      return findTitle.findPacking(props.lang, val)
    }
    if (title.toLowerCase() === 'težina' && props.display_locale) {
      return findTitle.findWeight(props.lang, val)
    }
    if (title.toLowerCase() === 'rasa' && props.display_locale) {
      return findTitle.findBreed(props.lang, val)
    }

    if (props.display_month && title === 'month') {
      return (
        listOfMonths.months.find((x) => x.value === val)?.name ?? val
      )
    }

    const rawFields = ['Jedinica mere', 'Težina', 'Rasa', 'Pakovanje', 'month', 'Godina']

    if (val != null && !rawFields.includes(title)) {
      return exchange(props.lang, val)
    }

    return val
  } catch (e) {
    return val
  }
}

const exchange = (lang, value) => {
  const num = parseFloat(value)
  if (isNaN(num)) return value

  switch (lang) {
    case 'sr':
      return num + ' din'
    case 'en':
      if (!props.rate?.rate) return num
      const eur = num / props.rate.rate
      return eur.toFixed(2) + ' €'
    default:
      return num
  }
}
</script>

 


 
